import threeDots from "./three-dots.html";
import "./three-dots.css";

export default threeDots;